import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { StyledCell } from './styles';
import type { GridCellProps } from './types';

export type { GridCellProps } from './types';

type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof GridCellProps>;
type Props = DivProps & GridCellProps;

export const GridCell = forwardRef<HTMLDivElement, Props>(({ children, xs, s, m, l, ...props }, ref) => (
  <StyledCell xs={xs} s={s} m={m} l={l}>
    <div {...props} ref={ref}>
      {children}
    </div>
  </StyledCell>
));

GridCell.displayName = 'Grid.Cell';
